import type { AthenaPostgresPool } from "../../postgres/driver.ts";
import type {
	EventIngressDatabase,
	EventIngressQueryResult,
} from "./persistence.ts";

function toEventIngressQueryResult<T>(
	result: { rowCount?: number | null; rows: unknown[] },
): EventIngressQueryResult<T> {
	return {
		rowCount: result.rowCount ?? result.rows.length,
		rows: result.rows as T[],
	};
}

export function eventIngressDatabaseFromPool(
	pool: AthenaPostgresPool,
): EventIngressDatabase {
	return {
		async query<T = Record<string, unknown>>(
			text: string,
			values?: unknown[],
		) {
			const result = await pool.query(text, values);
			return toEventIngressQueryResult<T>(result);
		},
		async transaction(fn) {
			const client = await pool.connect();
			const tx: EventIngressDatabase = {
				async query<T = Record<string, unknown>>(
					text: string,
					values?: unknown[],
				) {
					const result = await client.query(text, values);
					return toEventIngressQueryResult<T>(result);
				},
				transaction(inner) {
					return inner(tx);
				},
			};
			try {
				await client.query("BEGIN");
				const result = await fn(tx);
				await client.query("COMMIT");
				return result;
			} catch (error) {
				await client.query("ROLLBACK");
				throw error;
			} finally {
				client.release();
			}
		},
	};
}
